import React, { useEffect, useState } from "react";
import Avatar from "react-avatar-edit";
import { Modal, Box, Skeleton } from "@mui/material";
import { AvatarBox, Span } from "../../styles";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import { useSelector } from "react-redux";
import ProfileImage from "../../../../Assets/Images/vector.png";
import { uploadAvatarSX } from "./Styles/uploadAvatarStyles";

export const UploadAvatar = ({ onUpload }) => {
  const [preview, setPreview] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const userData = useSelector((state) => state.userData.data);
  const avatar = userData?.educator?.profile?.avatar
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    if (preview) {
      onUpload(preview);
    }
    setOpen(false);
  };
  const onClose = () => {
    setPreview(null);
  };
  const onCrop = (view) => {
    setPreview(view);
  };
  useEffect(() => {
    if (preview) {
      setShowPreview(true);
    } else {
      setShowPreview(false);
    }
  }, [preview]);
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={uploadAvatarSX.modal}
        disableScrollLock
      >
        <AvatarBox>
          <Avatar
            alt="image not found"
            width={200}
            height={200}
            onCrop={onCrop}
            onClose={onClose}
            mimeTypes="image/jpeg,image/png,image/webp"
            exportAsSquare={false}
          />
          <Box
            sx={uploadAvatarSX.confirmButtonBox}
            onClick={handleClose}
          >
            <Span>
              <CheckIcon style={{ color: "#FFFFFF" }} />
            </Span>
          </Box>
        </AvatarBox>
      </Modal>
      <Box sx={uploadAvatarSX.outerBox}>
        <Box sx={uploadAvatarSX.avatarWrapper}>
            {!imageLoaded && (
              <Skeleton
                variant="circular"
                sx={uploadAvatarSX.skeleton}
              />
            )}
            <img
              src={
                showPreview && preview
                  ? preview
                  : avatar
                  ? `${avatar}?t=${Date.now()}`
                  : ProfileImage
              }
              height={200}
              width={200}
              alt="Preview"
              onLoad={() => setImageLoaded(true)}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = ProfileImage;
                setImageLoaded(true);
              }}
              style={{
                display: imageLoaded ? 'block' : 'none',
                objectFit: 'cover',
                borderRadius: '50%',
              }}
            />
        </Box>
      </Box>
      <Box
        onClick={handleOpen}
        sx={uploadAvatarSX.editIconBox}
        p={0.5}
      >
        <EditIcon fontSize="large" sx={{ color: (theme) => theme.palette.primary.main }} />
      </Box>
    </div>
  );
};
